import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const addNewDocOperations = async (
  docTypeName: string,
  setLoading: (isLoading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (docTypeName.length < 3 || docTypeName.length > 19) {
      toast.warn('על שם סוג המסמך להיות בין 3 ל20 תווים בלבד');
    }
    setLoading(true);
    const createDocType = await appApi.addDocType(docTypeName);
    globalSettingsStores.docTypes.push(createDocType.data.body);
    setLoading(false);
    closeDialog();
  } catch (e) {
    toast.error(`לא ניתן לבצע את הפעולה נסה שוב בעוד מספר רגעים`);
    setLoading(false);
  }
};
